import { Module, ParameterValue } from '@philips-internal/oswald-ui-foundation/lib/context';
import TwsParametersConstants from '../constants/TwsParametersConstants';

export interface ParametersModule {
  cdFunction: string;
  name: string;
  parameters: Map<string, ParameterValue>;
  nrSequencia: string;
  paramValue: string;
  cdFuncao: string;
}

function availableModulesMapper(tasyParameters: ParametersModule[], twsParameters: ParametersModule[]): Module[] {

  function getParameters(parameters: Map<string, ParameterValue>): Map<string, ParameterValue> {
    const parametersMap: Map<string, ParameterValue> = new Map();

    if (parameters) {
      for (const [key, value] of Object.entries(parameters)) {
        parametersMap.set(key, value);
      }
    }

    return parametersMap;
  }

  const twsParametersAux = twsParameters.filter(item => item.name != null);

  const modules: Module[] = twsParametersAux.map((twsParam: ParametersModule) => ({
    id: twsParam.cdFunction,
    name: twsParam.name,
    parameters: getParameters(twsParam.parameters)
  }));

  const paramModule: ParametersModule[] = twsParameters.filter(item => item.paramValue != null);

  const parametersAndValues: Map<string, ParameterValue> = new Map();

  paramModule.forEach(param => {
    parametersAndValues.set(param.nrSequencia.toString(), param.paramValue)
  })

  twsParameters.map(parameter => {
    if (parameter.nrSequencia === TwsParametersConstants.ALLOW_TO_CREATE_USER && parameter.paramValue === 'N') {
      const index = modules.findIndex(i => i.name === 'results.user.management');
      if (index > -1) {
        modules.splice(index, 1);
      }
    }

    const module = {
      id: '9125',
      name: '9125',
      parameters: parametersAndValues
    }

    if (!modules.find(item => item.id == '9125')) {
      modules.push(module);
    }
  });

  tasyParameters.forEach(tasyParam => {
    const data = {
      id: tasyParam.cdFunction,
      name: tasyParam.name,
      parameters: getParameters(tasyParam.parameters)
    }

    modules.push(data);
  });

  return modules;

}

export {
  availableModulesMapper
}
